import { nanoid } from 'nanoid';

/**
 * 一意なメッセージIDを生成します。
 * @param size IDの長さ (デフォルト: 16)
 * @returns 生成されたID
 */
export function generateMessageId(size: number = 16): string {
  return nanoid(size);
}

/**
 * 指定されたオリジンが許可リストに含まれているか検証します。
 * ワイルドカード (`*`) は許可しません (セキュリティリスクのため)。
 * @param targetOrigin 検証対象のオリジン
 * @param allowedOrigins 許可するオリジンのリスト
 * @returns 許可されていれば true、そうでなければ false
 */
export function isValidOrigin(targetOrigin: string, allowedOrigins: string[]): boolean {
  if (targetOrigin === '*' || allowedOrigins?.includes('*')) {
    return true
  }
  if (!targetOrigin || targetOrigin === '*' || allowedOrigins.includes('*')) {
    // セキュリティのため、'*' は明示的に許可しない
    // targetOrigin が null や undefined の場合も不正とする
    console.warn(
      '[IFrameMessageCommunication] Invalid origin check: Wildcard origin or null/undefined origin is not allowed for security reasons.',
      {
        targetOrigin,
        allowedOrigins,
      },
    );
    return false;
  }

  try {
    const targetUrl = new URL(targetOrigin);
    const target = targetUrl.origin; // プロトコル + ホスト名 + ポート番号 を取得

    return allowedOrigins.some((allowed) => {
      try {
        const allowedUrl = new URL(allowed);
        return allowedUrl.origin === target;
      } catch (e) {
        // allowedOrigins に不正なURLが含まれている場合
        console.warn(
          '[IFrameMessageCommunication] Invalid URL found in allowedOrigins:',
          allowed,
        );
        return false;
      }
    });
  } catch (e) {
    // targetOrigin が不正なURLの場合
    console.warn(
      '[IFrameMessageCommunication] Invalid targetOrigin provided:',
      targetOrigin,
    );
    return false;
  }
}

/**
 * デバッグログを出力します。
 * @param enabled デバッグが有効か
 * @param args 出力する内容
 */
export function debugLog(enabled: boolean, ...args: any[]): void {
  if (enabled) {
    console.debug('[IFrameMessageCommunication]', ...args);
  }
}
